import { render, staticRenderFns } from "./InquiryItinerary.vue?vue&type=template&id=787b153d&"
import script from "./InquiryItinerary.vue?vue&type=script&lang=js&"
export * from "./InquiryItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports